"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    body2ClassNames: function() {
        return body2ClassNames;
    },
    useBody2Styles: function() {
        return useBody2Styles;
    }
});
const _react = require("@griffel/react");
const body2ClassNames = {
    root: 'fui-Body2'
};
const useBody2Styles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}"
    ]
}); //# sourceMappingURL=useBody2Styles.styles.js.map
